import React, { useState } from 'react'
import styled, { css } from "styled-components"
import { PointsIcon } from "../../components/Icons/PointsIcon"
import { CoinsIcon } from '../../components/Icons/CoinsIcon'
import { CompoundingIcon } from '../../components/Icons/CompoundingIcon'
import crabIcon from '../../assets/seasons/CRAB.svg'
import straightLoader from '../../assets/icons/loader-straight.svg'
import CountUp from 'react-countup'
import { formatDisplay, formatDisplayShorthand } from '../../utils/formatDisplay'
import { DropdownIconUp, DropdownIconDown } from '../../components/Icons/DropdownIcon'
import { itemsMap } from '../Booty/Items'
import { Media } from '../../styles'
import { SeasonFilter } from './components/FilterSeasonDropdown'
import { CURRENT_SEASON } from '@/types/ChartTypes'

export const PointsDetails = (props: { 
    compoundedPoints: number, 
    totalShellPoints: number, 
    forecastedPointsGain: number, 
    boost: any, 
    totalValue: number,
    seasonFilter: SeasonFilter,
    crabBalance: string,
    isOwnWallet: boolean
}) => {
  const { compoundedPoints, totalShellPoints, forecastedPointsGain, boost, totalValue, seasonFilter, crabBalance, isOwnWallet } = props;

  const [pointCounter, setPointCounter] = useState<any>({ start: 0, end: totalShellPoints, duration: 1 })
  const [boostDetailsVisible, setBoostDetailsVisible] = useState(false)

  const formatShellPoints = (points: number) => formatDisplay(Math.round(points).toString(), 0)

  return (
    <PointsDetailsWrapper>
      <PointsHeader>
        <HeaderSubtitle>{isOwnWallet ? 'My' : ''} Shell Points</HeaderSubtitle>
      </PointsHeader>
      <Column>
        <ValueColumn>
          <PointsIcon />
          {
            <Value num={totalShellPoints}>
              <CountUp
                start={pointCounter.start}
                end={pointCounter.end}
                duration={pointCounter.duration}
                formattingFn={formatShellPoints}
                onEnd={() => {
                  if (pointCounter.start == 0) {
                    setPointCounter({
                      start: totalShellPoints,
                      end: totalShellPoints + (seasonFilter.label != CURRENT_SEASON || forecastedPointsGain < 1 ? 0 : forecastedPointsGain),
                      duration: 60 * 60 * 24
                    })
                  } else {
                    window.location.reload();
                  }
                }}
              />
            </Value>
          }
        </ValueColumn>
      </Column>
      {seasonFilter.label == CURRENT_SEASON ? 
        <Statistics>
            <StatisticsItem>
                <StatisticsTitle>Next 24h Gain</StatisticsTitle>
                <StatisticsImage>
                    <PointsIcon />
                </StatisticsImage>
                <StatisticsValue>
                    {forecastedPointsGain == -1 ? <ForecastLoader src={straightLoader} /> : formatDisplayShorthand(forecastedPointsGain)}
                </StatisticsValue>
            </StatisticsItem>
            <StatisticsItem>
                <StatisticsTitle>$CRAB</StatisticsTitle>
                <StatisticsImage>
                    <img src={crabIcon}/>
                </StatisticsImage>
                <StatisticsValue>
                    {crabBalance}
                </StatisticsValue>
            </StatisticsItem>
            {/* <StatisticsItem>
                <StatisticsTitle>Compounded Points</StatisticsTitle>
                <StatisticsImage>
                    <CompoundingIcon/>
                </StatisticsImage>
                <StatisticsValue>
                    {formatDisplayShorthand(compoundedPoints)}
                </StatisticsValue>
            </StatisticsItem> */}
            <StatisticsItem>
                <StatisticsTitle>Active Boost</StatisticsTitle>
                <StatisticsImage>
                    <img src={`../../assets/icons/boost.svg`} />
                </StatisticsImage>
                <StatisticsValue>
                    {`${formatDisplay((boost.currentBoost ?? 1).toString(), 3)}x`}
                    {
                    boost.currentBoost > 1 &&
                    <ExpandButton onClick={() => setBoostDetailsVisible(!boostDetailsVisible)}>
                        {boostDetailsVisible ? <DropdownIconUp /> : <DropdownIconDown />}
                    </ExpandButton>
                    }
                    <TooltipBox visible={boostDetailsVisible}>
                    <Column style={{ 'rowGap': '4px' }}>
                        {
                        boost.activatedArtifacts && Object.keys(boost.activatedArtifacts).map((artifactIndex: any) =>
                            <Artifact
                            key={artifactIndex}
                            src={`../../assets/booty/${itemsMap[parseInt(artifactIndex)].image}.jpg`}
                            style={{ width: '32px', height: '32px', margin: 0}}
                            chad={parseFloat(boost.activatedArtifacts[artifactIndex].chadTimeRemaining) > 0}
                            />
                        )
                        }
                    </Column>
                    <Column style={{ width: 'fit-content', rowGap: '4px' }}>
                        {
                        boost.activatedArtifacts && Object.keys(boost.activatedArtifacts).map((artifactIndex: any) =>
                            <div key={artifactIndex} style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', height: '32px' }}>
                            <img style={{ width: '16px', marginRight: '4px' }} src={`../../assets/icons/boost.svg`} />
                            <BoostValue style={{ fontSize: '14px' }}>{`${itemsMap[parseInt(artifactIndex)].effect?.value}%`}</BoostValue>
                            </div>
                        )
                        }
                    </Column>
                    <Column style={{ width: 'fit-content', rowGap: '4px' }}>
                        {
                        boost.activatedArtifacts && Object.keys(boost.activatedArtifacts).map((artifactIndex: any) => {
                            const days = parseInt(boost.activatedArtifacts[artifactIndex].timeRemaining)
                            const hours = Math.floor((boost.activatedArtifacts[artifactIndex].timeRemaining - days) * 24)
                            return (
                            <div key={artifactIndex} style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', height: '32px' }}>
                                <img style={{ width: '16px', marginRight: '4px' }} src={`../../assets/icons/time.svg`} />
                                <BoostValue>{`${days == 0 ? '' : days + 'd'} ${hours == 0 ? days == 0 ? '<1h' : '' : hours + 'h'}`}</BoostValue>
                            </div>
                            )
                        })
                        }
                    </Column>
                    </TooltipBox>
                </StatisticsValue>
            </StatisticsItem>
            <StatisticsItem>
                <StatisticsTitle>Wallet Value (USD)</StatisticsTitle>
                <StatisticsImage>
                    <CoinsIcon />
                </StatisticsImage>
                <StatisticsValue>
                    {'$' + formatDisplayShorthand(totalValue)}
                </StatisticsValue>
            </StatisticsItem>
        </Statistics>
      :
        seasonFilter.label == 'Season One' && <StatisticsItem>
            <StatisticsTitle>Compounded Points</StatisticsTitle>
            <StatisticsImage>
                <CompoundingIcon/>
            </StatisticsImage>
            <StatisticsValue>
                {formatDisplayShorthand(compoundedPoints)}
            </StatisticsValue>
        </StatisticsItem>
       }
    </PointsDetailsWrapper>
  )
}

const PointsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  row-gap: 12px;
  width: 100%;
  max-width: 100%;
  flex-wrap: wrap;
`

const PointsDetailsWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  padding: 0px 24px 0 24px;

  ${Media.tablet} {
    flex-direction: column;
    justify-content: unset;
    align-items: unset;
    column-gap: unset;
    padding: 0 8px 0;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;

  & > svg {
    width: 18px;
    height: 18px;
    color: #00BDFF;
    margin: 0 8px;
}

& > img {
    width: 18px;
    height: 18px;
    color: #00BDFF;
    margin: 0 8px;
}
`

const Subtitle = styled.h4`
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #7D7D97;

  ${Media.tablet} {
    font-size: 12px;
    line-height: 14px;
  }
`

const HeaderSubtitle = styled(Subtitle)`
  ${Media.tablet} {
    font-size: 14px;
    line-height: 16px;
  }
`

const ValueColumn = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  column-gap: 12px;
  margin-top: 12px;

  & > svg {
    color: #00BDFF;
  }
`

const Value = styled.span<{num : number}>`
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  letter-spacing: -0.03em;
  color: #ffffff;
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ num }) => num >= 100000000 && css`
    font-size: 42px;
  `};
`

const BoostValue = styled.p`
  font-size: 13px;
  color: #ffffff;
  font-weight: 100;
`

// const Statistics = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   column-gap: 24px;
//   row-gap: 24px;
//   width: fit-content;
//   max-width: 100%;
//   margin: 16px 0 8px;
//   height: fit-content;

//   & > :first-child {
//     justify-self: end;
//   }

//   & > :nth-child(3) {
//     justify-self: end;
//   }

//   ${Media.tablet} {

//     & > :first-child {
//         justify-self: start;
//     }

//     & > :nth-child(3) {
//       justify-self: start;
//     }
//   }
// `

const Statistics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: end;
  column-gap: 24px;
  row-gap: 24px;
  width: fit-content;
  max-width: 100%;
  margin: 16px 0 8px;
  height: fit-content;

  ${Media.smallDesktop} {
    justify-items: start;
  }
`

const StatisticsItem = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  column-gap: 8px;
  row-gap: 4px;
  overflow: hidden;

  ${Media.tablet} {
    display: grid;
    grid-template-columns: 20px auto;
    grid-template-areas: 
      'title title'
      'image value';
  }
`

const StatisticsTitle = styled.p`
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #7D7D97;
  
  ${Media.tablet} {
    grid-area: title;
    font-size: 12px;
    line-height: 18px;
  }
`

const StatisticsImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  max-width: 20px;
  height: 20px;
  max-height: 20px;
  color: #00BDFF;
  overflow: hidden;

  & > img,
  & > svg {
    max-width: 100%;
    max-height: 100%;
    color: inherit;
  }

  ${Media.tablet} {
    grid-area: image;
  }
`

const ClaimButton = styled.button`
  width: 72px;
  height: 32px;

  margin-left: 8px;

  &:hover {
    background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
    border: solid 1.5px #000E47;
    color: #000E47;
  }

  border: solid 1.5px #00BDFF;
  border-radius: 8px;
  color: #00BDFF;
`;

const ExpandButton = styled.button`
  align-items: center;
  width: 20px;
  height: 20px;

  &:hover {
    opacity: 0.7;
  }
`;

const TooltipBox = styled.div<{ visible: boolean }>`
  display: flex;
  justify-content: space-evenly;
  position: absolute;
  margin-top: 12px;
  margin-left: -112px;
  column-gap: 4px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: 174px;
  padding: 4px 4px;
  border-radius: 8px;
  box-shadow: 0 0px 6px #00BDFF;
  background-color:  #1E2239;

  ${({ visible }) => visible && css`
    visibility: visible;
  `};

  ${Media.tablet}{
    margin-left: -26px;
  }

`;

const StatisticsValue = styled.span`
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  color: #FFFFFF;
  
  ${Media.tablet} {
    grid-area: value;

    font-size: 16px;
    line-height: 20px;
  }
`

const Artifact = styled.img<{chad? : boolean}>`
    width: 36px;
    border-radius: 6px;
    border: 1px solid #1E2239;

    ${({ chad }) => chad && css`
        box-shadow: 0 0px 4px #0ADD08;
    `};
`

const ForecastLoader = styled.img`
  width: 28px;
  margin-bottom: 4px;
`;